import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonLayoutModule, CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TmcYardCommonModule } from '../../../common/common.module';
import { ApplicationClientCommonModule,  ServiceResponseModule } from '@sdbn/common';
import { CEPTabletWidgetComponent } from './component/cep-tablet-widget.component';
import { CEPTabletModule } from '../../../control/cep-tablet/cep-tablet.module';
import { TransportDetailsModule } from '../../../common/components/transport-details/transport-details.module';

@NgModule({
  declarations: [
    CEPTabletWidgetComponent
  ],
  imports: [
    CommonModule,

    CommonLayoutModule,
    CommonUIModule,
    ReactiveFormsModule,
    FormsModule,
    TmcYardCommonModule,
    TransportDetailsModule,
    ServiceResponseModule,
    CommonTranslationModule,
    ApplicationClientCommonModule,
    CEPTabletModule
  ]
})
export class CEPTabletWidgetModule { }
